import { render, staticRenderFns } from "./MerchantList.vue?vue&type=template&id=3929d637&scoped=true&"
import script from "./MerchantList.vue?vue&type=script&lang=js&"
export * from "./MerchantList.vue?vue&type=script&lang=js&"
import style0 from "./MerchantList.vue?vue&type=style&index=0&id=3929d637&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3929d637",
  null
  
)

export default component.exports